import { checkIfSharePointListExist } from "../../../services/GraphService";
import { IItemCheck } from "./IItemCheck";

export class SharepointListCheck implements IItemCheck {
    constructor(private listId: string, private siteId: string) { }
    
    doesItemExist = async () => {
        return await checkIfSharePointListExist(this.listId, this.siteId);
    };
}